import React from 'react';
import { Modal } from 'antd';
import SelectMerchant from '@/component/login/login_v5/select-merchant'
import './index.less';

const SwitchMerchant = (props) => {
  const { visible, onCancel } = props;
  
  const handleSelectMerchant = () => {
    window.location.reload();
  };

  return (
    <Modal
      width="438px"
      title="切换商户"
      wrapClassName="dialog-switch-merchant"
      open={visible}
      footer={null}
      onCancel={()=>{
        if (onCancel) onCancel();
      }}
    >
      <SelectMerchant
        height="330px"
        showDescLabel={true}
        onSelect={handleSelectMerchant}
      ></SelectMerchant>
    </Modal>
  )
};

export default SwitchMerchant;